import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { OidcCallback, OidcLogout } from '@vigilantapps/ui-library'
import { supportedIMApps } from '@/services/chats/consts'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/oidc-callback',
    name: 'oidc-callback',
    component: OidcCallback
  },
  {
    path: '/logout',
    name: 'oidc-logout',
    component: OidcLogout
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/SearchView.vue'),
    meta: {
      title: 'Notification Search'
    }
  },
  {
    path: '/:day/notifications/:nid',
    name: 'notification',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/NotificationView.vue'),
    meta: {
      title: 'Notification Viewer'
    }
  },
  {
    path: '/notifications/by-id/:day/:nid',
    name: 'legacy-notification-viewer',
    redirect: to => ({
      name: 'notification',
      params: { ...to.params },
    })
  },
  {
    path: '/subjects',
    name: 'subjects',
    component: () => import(/* webpackChunkName: "devices" */ '../views/SubjectsView.vue'),
    meta: {
      title: () => 'Monitored'
    }
  },
  {
    path: '/subjects/:id',
    name: 'subject',
    component: () => import(/* webpackChunkName: "devices" */ '../views/SubjectView.vue'),
    meta: {
      title: (vm) => {
        return `Device ${vm.$route.params.id}`
      }
    }
  },
  {
    path: '/policies',
    name: 'policies',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PoliciesView.vue'),
    meta: {
      title: 'Policy-Sets'
    }
  },
  {
    path: '/policies/:name',
    name: 'policy',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PolicyView.vue'),
    meta: {
      title: vm => `${vm.$route.params.name} Policy`
    }
  },
  {
    name: 'device-policy',
    path: '/subjects/:device/with-policy/:name',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PolicyView.vue'),
    meta: {
      title: 'Device Policy'
    }
  },
  {
    path: '/subjects/:device/new-property',
    name: 'new-device-property',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PropertyView.vue'),
    meta: {
      title: 'New Device Property'
    }
  },
  {
    path: '/rules/:id',
    name: 'rule',
    component: () => import(/* webpackChunkName: "policies" */ '../views/RuleView.vue'),
    meta: {
      title: 'Rule Editor'
    }
  },
  {
    path: '/policies/:project/new-rule',
    name: 'new-project-rule',
    component: () => import(/* webpackChunkName: "policies" */ '../views/RuleView.vue'),
    meta: {
      title: 'New Rule'
    }
  },
  {
    name: 'new-device-rule',
    path: '/subjects/:device/new-rule',
    component: () => import(/* webpackChunkName: "policies" */ '../views/RuleView.vue'),
    meta: {
      title: 'New Device Rule'
    }
  },
  {
    path: '/properties/:id',
    name: 'property',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PropertyView.vue'),
    meta: {
      title: 'Property Editor'
    }
  },
  {
    path: '/policies/:project/new-property',
    name: 'new-project-property',
    component: () => import(/* webpackChunkName: "policies" */ '../views/PropertyView.vue'),
    meta: {
      title: 'New Property'
    }
  },
  {
    path: '/messenger',
    name: 'messenger',
    component: () => import(/* webpackChunkName: "messenger" */ '../views/MessengerView.vue'),
    meta: {
      title: () => 'Messenger'
    }
  },
  {
    path: '/messenger/:app',
    name: 'messenger-app',
    component: () => import(/* webpackChunkName: "messenger" */ '../views/MessengerView.vue'),
    meta: {
      title: (vm) => supportedIMApps[vm.$route.params.app].name
    }
  },
  {
    path: '/messenger/:app/:deviceId',
    name: 'messenger-app-device',
    component: () => import(/* webpackChunkName: "messenger" */ '../views/MessengerView.vue'),
    meta: {
      title: (vm) => `${supportedIMApps[vm.$route.params.app].name} Chats`
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/components/SettingsLayer.vue'),
    children: [
      {
        path: '/exclusion-policies',
        name: 'exclusions',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/ExclusionsView.vue')
      },
      {
        path: '/user',
        name: 'user-settings',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/UserSettings.vue')
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
